import { useState } from 'react';
import logger from '../../../utils/logger';
import { getVersionViewData } from '../../../api/api';
import { MarkerType } from '@xyflow/react';
import CustomAlert from '../../../components/CustomAlert';

export const useSwimlaneVersionData = ({
  processId,
  level,
  version,
  currentParentId,
  setChiledNodes,
  setEdges,
  setSupportedLanguages,
  setprocessDefaultlanguage_id,
  setOriginalDefaultLanguageId,
  SetcurrentModeltitle,
  SetTitle,
}) => {
  const [contactInfo, setContactInfo] = useState(null);
  const [revisionInfo, setRevisionInfo] = useState(null);
  const [assignedUsers, setAssignedUsers] = useState([]);
  const [versionStatus, setVersionStatus] = useState(null);
  const [versionDate, setVersionDate] = useState(null);
  const [processImg, setProcessImg] = useState(null);

  const fetchVersionData = async (language_id = null) => {
    try {
      const response = await getVersionViewData(
        processId,
        level,
        version,
        'swimlane',
        currentParentId,
        language_id
      );

      const {
        nodes,
        edges,
        title: modelTitle,
        processDefaultlanguage_id: pLang,
        supportedLanguages: rawSupportedLanguages,
        OriginalDefaultlanguge_id,
        contact_info,
        revision_info,
        assigned_users,
      } = response;

      if (SetcurrentModeltitle) SetcurrentModeltitle(modelTitle);
      if (setprocessDefaultlanguage_id) setprocessDefaultlanguage_id(pLang);
      if (setSupportedLanguages) setSupportedLanguages(rawSupportedLanguages || []);
      if (setOriginalDefaultLanguageId) setOriginalDefaultLanguageId(OriginalDefaultlanguge_id);
      if (SetTitle) SetTitle(nodes[0]?.version);

      setContactInfo(contact_info);
      setRevisionInfo(revision_info);
      setAssignedUsers(assigned_users || []);
      setVersionStatus(response.status);
      setVersionDate(response.created_at);
      setProcessImg(response.Process_img);

      const nodebgwidth = document.querySelector('.react-flow__node');
      const nodebgwidths = nodebgwidth ? nodebgwidth.getBoundingClientRect().width : 0;

      const nodebgheight = document.querySelector('.react-flow__node');
      const nodebgheights = nodebgheight ? nodebgheight.getBoundingClientRect().height : 0;

      const groupWidth = nodebgwidths;
      const groupHeight = nodebgheights;
      const childWidth = groupWidth * 0.9;
      const childHeight = groupHeight * 0.9;

      const parsedNodes = nodes.map((node) => {
        const parsedData = JSON.parse(node.data || '{}');
        const parsedPosition = JSON.parse(node.position || '{"x":0,"y":0}');
        const parsedMeasured = node.measured ? JSON.parse(node.measured) : undefined;

        let centeredPosition = parsedPosition;

        if (node.parentId) {
          const parentNode = nodes.find((n) => n.node_id === node.parentId);
          if (parentNode && parentNode.position) {
            const parentPos = JSON.parse(parentNode.position);
            const parentWidth = groupWidth;
            const parentHeight = groupHeight;

            centeredPosition = {
              x: parentPos.x + parentWidth / 2 - childWidth / 2,
              y: parentPos.y + parentHeight / 2 - childHeight / 2,
            };
          }
        }

        const nodeStyle =
          node.type === 'Yes' || node.type === 'No' || node.type === 'FreeText'
            ? {}
            : {
                width: groupWidth,
                height: groupHeight,
                childWidth: childWidth,
                childHeight: childHeight,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              };

        return {
          ...node,
          data: {
            ...parsedData,
            width_height: parsedMeasured,
            defaultwidt: '40px',
            defaultheight: '40px',
            nodeResize: false,
          },
          type: node.type,
          id: node.node_id,
          parentNode: node.parentId,
          measured: parsedMeasured,
          position: centeredPosition,
          draggable: false,
          animated: Boolean(node.animated),
          style: nodeStyle,
        };
      });

      const parsedEdges = edges.map((edge) => {
        let parsedData = {};
        if (edge.data) {
          try {
            parsedData = typeof edge.data === 'string' ? JSON.parse(edge.data) : edge.data;
          } catch (e) {
            logger.error('Error parsing edge data', e);
          }
        }

        return {
          ...edge,
          id: edge.edge_id || edge.id,
          animated: Boolean(edge.animated),
          markerEnd: {
            type: MarkerType.ArrowClosed,
            color: '#002060',
            width: 12,
            height: 12,
          },
          style: { stroke: '#002060', strokeWidth: 2 },
          type: edge.type && !edge.type.startsWith('{') ? edge.type : 'waypointEdge',
          data: parsedData,
        };
      });

      setChiledNodes(parsedNodes);
      setEdges(parsedEdges);
    } catch (error) {
      logger.error('Error fetching version data:', error);
      CustomAlert.error('Error', 'Error fetching versioned data');
    }
  };

  const handleLanguageSwitch = (langId) => {
    fetchVersionData(langId);
  };

  return {
    contactInfo,
    revisionInfo,
    assignedUsers,
    versionStatus,
    versionDate,
    processImg,
    fetchVersionData,
    handleLanguageSwitch,
  };
};
